import React from 'react'
import { AdminPanelPage } from '../AdminPanelPage'
import { BreadcrumbProps } from '@aidkitorg/component-library'
import { useLocalizedStrings } from '../../Localization'

export const SettingsPage = () => {
  const L = useLocalizedStrings()

  const breadcrumbs: BreadcrumbProps['items'] = [
    {
      label: L.admin_panel.settings.settings
    }
  ]

  return (
    <AdminPanelPage
      title={L.admin_panel.settings.settings} 
      breadcrumbs={breadcrumbs}
    >
    </AdminPanelPage>
  )
}